<template>
  <custom-overlay class="">
    <div class="text-center h-full bg-white" style="padding-top: 20vh">
      <img src="/assets/img/gray-logo.png" alt="" width="128" />
      <div class="my-6">您之前已经回答了 {{ data }} 题，是否继续上次回答？</div>
      <div class="py-6">
        <el-button @click="onRestart">重新开始</el-button>
        <el-button @click="onContinue" type="primary">继续答题</el-button>
      </div>
    </div>
  </custom-overlay>
</template>

<script>
import CustomOverlay from '@/components/overlay/CustomOverlay'

export default {
  name: 'Breakpoint',
  components: { CustomOverlay },
  props: {
    data: {
      type: Number,
      default: 0
    }
  },
  methods: {
    onRestart() {
      this.$emit('restart')
    },
    onContinue() {
      this.$emit('continue')
    }
  }
}
</script>

<style scoped></style>
